import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import { useLogo } from 'reservations/account/hooks/UseLogo';
import { useRestaurantName } from 'reservations/account/providers/ConfigProvider';
import Header from 'reservations/base/components/Header';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';
import { WHITE } from 'reservations/brand/constants';

type ImageProps = {
  isDesktop: boolean;
};

const Image = styled('img')<ImageProps>(({ isDesktop }) => ({
  objectFit: 'contain',
  minHeight: '70px',
  maxHeight: '120px',
  minWidth: '70px',
  maxWidth: isDesktop ? '560px' : '300px'
}));

export const TextAndLogoLayout = () => {
  const restaurantName = useRestaurantName();
  const logo = useLogo();
  const isDesktop = useIsDesktop();

  return (
    <Grid
      data-testid="text-and-logo-layout"
      sx={{
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'start',
        columnGap: '1rem'
      }}
    >
      <Paper
        data-testid="logo-wrapper"
        sx={{
          backgroundColor: 'transparent',
          width: 'inherit',
          boxShadow: 0,
          display: 'flex',
          justifyContent: isDesktop ? 'start' : 'flex-center',
          alignItems: 'start'
        }}
      >
        <Image
          isDesktop={isDesktop}
          src={logo?.url}
          alt={logo?.alt_text}
          data-testid="logo-small"
        />
      </Paper>

      <Header
        text={restaurantName}
        color={WHITE}
        fontSize={`${560 / restaurantName?.length}px`}
      />
    </Grid>
  );
};
